import { RoleChipContainer } from './styles'

export const RoleChip = ({ label }) => {
  return <RoleChipContainer>{label}</RoleChipContainer>
}
